export const PATH = '/home';
